<template>
  <v-list dense class="pt-0">
    <v-list-tile v-for="item in sideMenuItems" :key="item.title" :to="{name: item.target}">
      <v-list-tile-action>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  data: () => ({
    sideMenuItems: [
      { title: 'Админка', icon: '', target: 'adminDashboard' },
      { title: 'Периоды', icon: 'lightbulb_outline', target: 'adminPeriods' },
      { title: 'Институты', icon: 'lightbulb_outline', target: 'adminInstitutions' },
      { title: 'Кафедры', icon: 'lightbulb_outline', target: 'adminDepartments' },
      { title: 'Преподаватели', icon: 'lightbulb_outline', target: 'adminTeachers' },
      { title: 'Индикаторы', icon: 'lightbulb_outline', target: 'adminIndicators' }
    ]
  })
}
</script>
